import { render, staticRenderFns } from "./manageSharedLicenseDialog.vue?vue&type=template&id=4162c572&"
import script from "./manageSharedLicenseDialog.vue?vue&type=script&lang=tsx&"
export * from "./manageSharedLicenseDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./manageSharedLicenseDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports